import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.json.stringify.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("确认");

import { ref, computed, watch, nextTick } from 'vue';
import { getVexTableProps } from '@/config';
import { getControlSalesTeamList, relateTeam } from '@/request';
import { ElMessage } from 'element-plus';
import { init } from 'events';
export default {
  name: 'relateTeamModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    actDept: {
      type: [null, Object],
      default: null
    },
    relateTeamList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    let relateTeamList = [];
    watch(() => props.modelValue, newValue => {
      if (newValue) {
        relateTeamList = _getRelateTeamList(props.actDept.data.children);
      }
    });
    const search = ref('');
    const table = ref();
    const selectedSupplierIds = ref([]);
    const tableData = ref([]);
    const tableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '团队名称',
        field: 'supplierName',
        //   width: '150px',
        showOverflow: true
      }, {
        title: '联系人',
        field: 'linkMan',
        //   width: '150px',
        showOverflow: true
      }, {
        title: '联系人电话',
        field: 'linkPhone',
        //   width: '200px',
        showOverflow: true
      }, {
        title: '创建时间',
        field: 'createAt',
        //   width: '200px',
        showOverflow: true
      }, {
        title: '团队业务区域',
        field: 'supBusiScopName',
        //   width: '250px',
        showOverflow: true
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getControlSalesTeamList({
              page: page.currentPage,
              rows: page.pageSize,
              supplierCategories: '2,3',
              supplierName: search.value
            }).then(data => {
              res({
                total: data.total,
                result: data.rows
              }); // nextTick(() => {
              //     let selectedRows = data.rows.filter(item => {
              //         return relateTeamList.find(v => v == item.supplierId)
              //     })
              //     console.log('selectedRows', selectedRows)
              //     table.value.setCheckboxRow(selectedRows, true)
              // })

              setTimeout(() => {
                // console.log(relateTeamList)
                let selectedRows = data.rows.filter(item => relateTeamList.find(v => v === String(item.supplierId)));
                table.value.setCheckboxRow(selectedRows, true);
                selectedSupplierIds.value = relateTeamList;
                tableData.value = data.rows;
              }, 500);
            });
          })
        }
      }
    });

    function selectAllEvent({
      checked,
      records,
      reserves
    }) {
      let rows = tableData.value;
      rows.forEach(row => {
        let supplierId = row.supplierId;

        if (checked) {
          const selectedSupplierIdList = selectedSupplierIds.value.filter(item => item === String(supplierId));

          if (selectedSupplierIdList.length <= 0) {
            selectedSupplierIds.value.push(String(supplierId));
          }
        } else {
          let index = selectedSupplierIds.value.indexOf(String(supplierId));

          if (index !== -1) {
            selectedSupplierIds.value.splice(index, 1);
          }
        }
      });
      console.log('selectedSupplierIds', JSON.stringify(selectedSupplierIds.value));
    }

    function selectChangeEvent({
      checked,
      records,
      reserves,
      row
    }) {
      let supplierId = row.supplierId;

      if (checked) {
        const selectedSupplierIdList = selectedSupplierIds.value.filter(item => item === String(supplierId));

        if (selectedSupplierIdList.length <= 0) {
          selectedSupplierIds.value.push(String(supplierId));
        }
      } else {
        let index = selectedSupplierIds.value.indexOf(String(supplierId));

        if (index !== -1) {
          selectedSupplierIds.value.splice(index, 1);
        }
      }

      console.log('selectedSupplierIds', JSON.stringify(selectedSupplierIds.value));
    }

    function _getRelateTeamList(childrenList, initList = []) {
      let list = initList;
      childrenList.forEach(item => {
        if (item.supplierCategory === 2) {
          list.push(item.supplierId);
        } // if (item.children && item.children.length) {
        //   list.concat(_getRelateTeamList(item.children, list))
        // }

      }); // console.log(list);

      return list;
    }

    function confirm() {
      let selectedList = table.value.getCheckboxRecords();
      console.log('selectedList', JSON.stringify(selectedList)); // if (selectedList.length === 0) {
      //   ElMessage.warning('请选择销售团队');
      //   return;
      // }

      let {
        levelType,
        supplierId,
        id
      } = props.actDept.data;
      let body = {
        supplierId,
        structureId: levelType === '0' ? undefined : id,
        // saleSupplierIdList: selectedList.map((v) => v.supplierId)
        saleSupplierIdList: selectedSupplierIds.value
      };
      relateTeam(body).then(res => {
        let {
          success,
          msg
        } = res;

        if (success) {
          emit('success');
          visible.value = false;
        } else {
          ElMessage.error(msg);
        }
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "关联销售团队",
        "custom-class": "relate-team-modal",
        top: "20px",
        width: "70%"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "100px",
          onKeydown: _cache[2] || (_cache[2] = _withKeys($event => table.value.commitProxy('reload'), ["enter"]))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "团队名称"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: search.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => search.value = $event),
              class: "search-input",
              placeholder: "请输入团队名称"
            }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
              icon: "search",
              type: "primary",
              onClick: _cache[1] || (_cache[1] = $event => table.value.commitProxy('reload'))
            }, {
              default: _withCtx(() => [_hoisted_1]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _unref(visible) ? (_openBlock(), _createBlock(_component_vxe_grid, _mergeProps({
          key: 0
        }, _unref(tableOptions), {
          ref_key: "table",
          ref: table,
          onCheckboxChange: selectChangeEvent,
          onCheckboxAll: selectAllEvent,
          "checkbox-config": {
            reserve: true
          },
          "row-config": {
            keyField: 'supplierId'
          }
        }), null, 16)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};